<script setup lang="ts">
import { Eye, EyeOff } from 'lucide-vue-next'
import type { HTMLAttributes } from 'vue'
import { ref } from 'vue'

import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
  modelValue?: string | number
  defaultValue?: string | number
  class?: HTMLAttributes['class']
}>()
defineEmits<{ (e: 'update:modelValue', payload: string | number): void }>()

const visible = ref(false)
</script>

<template>
  <div class="relative">
    <Input
      v-bind="$attrs"
      :model-value="props.modelValue"
      :default-value="props.defaultValue"
      :type="visible ? 'text' : 'password'"
      :class="cn('pr-10', props.class)"
      @update:model-value="$emit('update:modelValue', $event)"
    />
    <button
      type="button"
      tabindex="-1"
      :aria-label="visible ? 'Hide password' : 'Show password'"
      class="text-muted-foreground hover:text-foreground absolute inset-y-0 right-0 flex items-center px-3"
      @click="visible = !visible"
    >
      <EyeOff v-if="visible" class="size-4" />
      <Eye v-else class="size-4" />
    </button>
  </div>
</template>
